export function withFreightCheckoutConsent(data, state, channel = "WEB") {
  const freight = state?.deliveryFee;
  if (freight?.fulfillment?.required !== true) return data;
  return {
    ...data,
    freightTermsAccepted: freight.freightTermsAccepted === true,
    freightTermsAcceptedChannel: channel,
  };
}

export default withFreightCheckoutConsent;
